<div class="container">
  <div class="div-img">
    <img src="assets/images/builtup.svg" />
  </div>
  <div class="login">
    <h1>Recuperação de senha</h1>
    <form class="login-inputs">
      <app-input
        type="email"
        label="E-mail"
        [placeholder]="'Digite'"
        class="input-login input-email"
        [labelColor]="updateCorLabel()"
        [(ngModel)]="login.TxEmail"
        ngDefaultControls
      ></app-input>
      <app-botao
        (click)="loginSubmit()"
        class="input-login button-desktop"
        text="Enviar"
        [disabled]="validarForm() ? false : true"
      ></app-botao>
    </form>
  </div>
</div>

<app-loader *ngIf="loader" />
